export function initPhoneCode() {
  document.addEventListener('click', e => {
    const option = e.target.closest('[data-phone-option]');
    if (!option) return;
    const container = option.closest('[data-dropdown]');
    if (!container) return;
    const flagSpan = container.querySelector('[data-phone-flag]');
    flagSpan.className = 'fi fi-' + option.dataset.iso + ' fis rounded-sm w-5 h-4 inline-block';
    container.querySelector('[data-phone-code]').textContent = option.dataset.code;
    container.querySelector('input[name="phone_code"]').value = option.dataset.code;
    container.querySelector('[data-dropdown-menu]').classList.add('hidden');
  });
}
